import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService1 from "../../../../services/ap_auto_appCommonService";

import SupplierConstants from "../../../../common/SupplierConstants";
import DataTable from "react-data-table-component";
import { currencyFormat } from "../../../../common/Validations";
import toast from "react-hot-toast";

import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { useDispatch } from "react-redux";
import { getInvoiceList } from "../../../../redux/feature/supplier_app/purchasingSlice";

const PaymentInModal = React.forwardRef((props, ref) => {
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [paymentType, setPaymentType] = useState("UPI");

  const dispatch = useDispatch();

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const modalData = {
    title: "Invoice Creation",
    successMsg: "",
  };

  const [parentInfo, setParentInfo] = useState();
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [getInvoiceLineItem, setInvoiceLineItem] = useState([]);

  const [getHeaderData, setHeaderData] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [wasModalShown, setWasModalShown] = useState(false);

  //   const totalTaxAmount = getHeaderData?.items?.reduce((acc, curr) => acc + curr.taxAmount, 0);

  // console.log(">>totalTaxAmount",totalTaxAmount)
  const [invoiceData, setInvoiceData] = useState({
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTotalInvoiceValue: "",
    items: [],
    dispCompanyBankDetails: [],
    invoiceBillDocument: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currencyCode: "",
    currency: "",
    vendorCode: "",
    vendorName: "",
    companyCodeCode: "",
    purchaseType: "",
    invoiceType: "",
    transactionType: "APPAY",
    module: "APAUTO",
  });

  const onInputChange = ({ target: { name, value } }) => {
    setInvoiceData((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const columns = [
    {
      name: "Sl.No",
      selector: (row) => row.slNo,
      sortable: true,
      width: "80px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.slNo} </p>
        </div>
      ),
    },
    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialLongText} </p>
        </div>
      ),
    },
    {
      name: "Customer",
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.customerName} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.orderQuantityLoad,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.orderQuantityLoad} </p>
        </div>
      ),
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitPrice} </p>
        </div>
      ),
    },
    {
      name: "Total Amount",
      selector: (row) => row.netValue,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.netValue} </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    setParentInfo(props?.invoiceinfo);
    if (props?.viewInvoiceData) {
      setInvoiceData(props?.viewInvoiceData);
      setViewInvoiceDataStatus(true);
    } else {
      setInvoiceData({
        vendorInvoiceNo: "",
        vendorInvoiceDate: "",
        vendorBasicValue: "",
        vendorTotalInvoiceValue: "",
        dispCustomerCode: "",
        items: [],
        dispCompanyBankDetails: [],
        invoiceBillDocument: "",
        purchasingDocumentNr: "",
        purchasingDocumentDate: "",
        purchasingDocumentValue: "",
        currencyCode: "",
        currency: "",
        vendorCode: "",
        vendorName: "",
        paymentTerms: "",
        incoTerms: "",
        companyCodeCode: "",
        purchaseType: "",
        invoiceType: "",
        dispgst: 0,
      });
      setInvoiceLineItem([]);
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    const items = invoiceData.items || [];

    const totalBasicAmount = items.reduce((acc, item) => {
      const amount = parseFloat(item.basicAmount) || 0;
      return acc + amount;
    }, 0);

    const gst = (totalBasicAmount * 18) / 100;
    const cgst = gst / 2;
    const sgst = gst / 2;
    const totalQuantity = items.reduce((acc, item) => {
      const qty = parseFloat(item.orderQuantityLoad) || 0;
      return acc + qty;
    }, 0);
    setInvoiceData((prev) => ({
      ...prev,
      dispgst: gst.toFixed(2),
      totalOrderQuantity: totalQuantity,
      vendorTaxValue: gst.toFixed(2),
      dispCGST: cgst.toFixed(2),
      dispSGST: sgst.toFixed(2),
    }));
  }, [invoiceData.items]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  useEffect(() => {
    if (!getShowSuccessModal && wasModalShown) {
      props.onHide(); // Call only when modal transitions from true → false
      setWasModalShown(false); // Reset tracker
    }
  }, [getShowSuccessModal, wasModalShown, props]);
  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleSave = async () => {
    const obj = {
      data: {
        ...invoiceData,
        ...parentInfo,
        ...getHeaderData,
        selectedPayment: paymentType,
        transactionType: "ARPAY",
      },
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    try {
      setDisabled(true);

      const item = await ItemService1.createPayment(obj);

      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);

        dispatch(getInvoiceList());
        // props.onsuccessdata(obj);
        //   props.onHide();
      } else {
        toast.error(item?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while saving invoice:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  const loadInitialPageData = async () => {
    // setLoading(true);

    if (props?.invoiceinfo?.documentNumber) {
      let obj = {
        queryName: "Get_APARInvoice_Detail",
        documentNumber: props?.invoiceinfo?.documentNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService1.generateCustomerQuery(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          // setHeaderData(item?.data);
          setHeaderData(item?.data[0]);
          setInvoiceLineItem(item?.data[0]?.items);
          // dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      // setLoading(false);
    }
  };
  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line
  }, [props]);
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Payment - {parentInfo?.documentNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Header Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">HD</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Header Details</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Document Number"
                      label={
                        <>
                          <i className="bi bi-hash labelIcon"></i>
                          Document Number
                        </>
                      }
                      name="documentNumber"
                      placeholder=""
                      value={getHeaderData?.documentNumber || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Document Date"
                      label={
                        <>
                          <i className="bi bi-calendar-date labelIcon"></i>
                          Document Date
                        </>
                      }
                      name="createdAt"
                      placeholder=""
                      value={getHeaderData?.createdAt || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Net Value"

                      label={
                        <>
                          <i className="bi bi-cash-stack labelIcon"></i>
                          Net Value
                        </>
                      }
                      name="purchasingDocumentValue"
                      placeholder=""
                      value={currencyFormat(
                        Number(getHeaderData?.purchasingDocumentValue).toFixed(
                          2,
                        ),
                      )}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Currency"
                      label={
                        <>
                          <i className="bi bi-currency-rupee labelIcon"></i>
                          Currency
                        </>
                      }
                      name="currency_display"
                      placeholder=""
                      value={`${getHeaderData?.currency_displayCode} - ${getHeaderData?.currency_display}`}
                      disabled={true}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Vendor Code"
                      label={
                        <>
                          <i className="bi bi-upc labelIcon"></i>
                          Vendor Code
                        </>
                      }
                      name="vendorCode"
                      placeholder=""
                      value={getHeaderData?.vendorCode || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      // label="Vendor Name"
                      label={
                        <>
                          <i className="bi bi-person-badge labelIcon"></i>
                          Vendor Name
                        </>
                      }
                      name="vendorName"
                      placeholder=""
                      value={getHeaderData?.vendorName || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding mt-4 pt-3"
                  >
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                        Header Text
                      </label>
                      <span
                        style={{ marginLeft: "15px" }}
                        // onClick={() =>
                        //   headerTextShowModal(getHeaderData?.headerTextData)
                        // }
                      >
                        <i className="bi bi-calendar2-week iconTable"></i>
                      </span>
                      <span className="suppliersIcon">
                        {" "}
                        {getHeaderData?.headerTextData?.length || 0}{" "}
                      </span>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Item Details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={columns}
                      data={getInvoiceLineItem}
                      // progressPending={loading}
                      pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      selectableRows
                      paginationRowsPerPageOptions={
                        SupplierConstants.ROW_PER_PAGE
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PM</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Payment Methods</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col md={12} className="d-flex gap-3">
                    <button
                      className={`paymentBtn ${paymentType === "UPI" ? "activeBtn" : ""}`}
                      onClick={() => setPaymentType("UPI")}
                    >
                      <i className="bi bi-phone"></i>
                      <span>UPI</span>
                    </button>

                    <button
                      className={`paymentBtn ${paymentType === "BANK" ? "activeBtn" : ""}`}
                      onClick={() => setPaymentType("BANK")}
                    >
                      <i className="bi bi-bank"></i>
                      <span>Bank</span>
                    </button>

                    <button
                      className={`paymentBtn ${paymentType === "CARD" ? "activeBtn" : ""}`}
                      onClick={() => setPaymentType("CARD")}
                    >
                      <i className="bi bi-credit-card"></i>
                      <span>Card</span>
                    </button>
                  </Col>

                  {paymentType === "UPI" && (
                    <>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="UPI ID"
                          label={
                            <>
                              <i className="bi bi-phone labelIcon"></i>
                              UPI ID
                            </>
                          }
                          name="upiId"
                          placeholder=""
                          value={invoiceData?.upiId || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Payer Name"
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Payer Name
                            </>
                          }
                          name="payerName"
                          placeholder=""
                          value={invoiceData?.payerName || ""}
                          onChange={onInputChange}

                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Receiver Name"
                          label={
                            <>
                              <i className="bi bi-person-check labelIcon"></i>
                              Receiver Name
                            </>
                          }
                          name="receiverName"
                          placeholder=""
                          value={invoiceData?.receiverName || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          // label="Transaction Date"
                          label={
                            <>
                              <i className="bi bi-calendar-date labelIcon"></i>
                              Transaction Date
                            </>
                          }
                          name="transactionDate"
                          id="transactionDate"
                          placeholder=""
                          value={invoiceData?.transactionDate || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="UTR Number"
                          label={
                            <>
                              <i className="bi bi-hash labelIcon"></i>
                              UTR Number
                            </>
                          }
                          name="utrNr"
                          placeholder=""
                          value={invoiceData?.utrNr || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Amount"

                          label={
                            <>
                              <i className="bi bi-currency-rupee labelIcon"></i>
                              Amount
                            </>
                          }
                          name="amountPaying"
                          placeholder=""
                          value={invoiceData?.amountPaying || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                    </>
                  )}
                  {paymentType === "BANK" && (
                    <>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Payer Name"
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Payer Name
                            </>
                          }
                          name="payerName"
                          placeholder=""
                          value={invoiceData?.payerName || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Receiver Name"

                          label={
                            <>
                              <i className="bi bi-person-check labelIcon"></i>
                              Receiver Name
                            </>
                          }
                          name="receiverName"
                          placeholder=""
                          value={invoiceData?.receiverName || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          // label="Transaction Date"
                          label={
                            <>
                              <i className="bi bi-calendar-date labelIcon"></i>
                              Transaction Date
                            </>
                          }
                          name="transactionDate"
                          id="transactionDate"
                          placeholder=""
                          value={invoiceData?.transactionDate || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Account Number"
                          label={
                            <>
                              <i className="bi bi-credit-card-2-front labelIcon"></i>
                              Account Number
                            </>
                          }
                          name="accountNumber"
                          placeholder=""
                          value={invoiceData?.accountNumber || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="IFSC Code"
                          label={
                            <>
                              <i className="bi bi-code-slash labelIcon"></i>
                              IFSC Code
                            </>
                          }
                          name="ifsc"
                          placeholder=""
                          value={invoiceData?.ifsc || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Bank Name"
                          label={
                            <>
                              <i className="bi bi-bank labelIcon"></i>
                              Bank Name
                            </>
                          }
                          name="bankName"
                          placeholder=""
                          value={invoiceData?.bankName || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Branch Name"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Branch Name
                            </>
                          }
                          name="branchName"
                          placeholder=""
                          value={invoiceData?.branchName || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Amount"

                          label={
                            <>
                              <i className="bi bi-currency-rupee labelIcon"></i>
                              Amount
                            </>
                          }
                          name="amountPaying"
                          placeholder=""
                          value={invoiceData?.amountPaying || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                    </>
                  )}
                  {paymentType === "CARD" && (
                    <>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Card Number"
                          label={
                            <>
                              <i className="bi bi-credit-card labelIcon"></i>
                              Card Number
                            </>
                          }
                          name="cardNumber"
                          placeholder=""
                          value={invoiceData?.cardNumber || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Expiry Date"
                          label={
                            <>
                              <i className="bi bi-calendar-date labelIcon"></i>
                              Expiry Date
                            </>
                          }
                          name="expiry"
                          type="date"
                          placeholder=""
                          value={invoiceData?.expiry || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="CVV"
                          label={
                            <>
                              <i className="bi bi-shield-lock labelIcon"></i>
                              CVV
                            </>
                          }
                          name="cvv"
                          placeholder=""
                          value={invoiceData?.cvv || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Amount"
                          label={
                            <>
                              <i className="bi bi-currency-rupee labelIcon"></i>
                              Amount
                            </>
                          }
                          name="amountPaying"
                          placeholder=""
                          value={invoiceData?.amountPaying || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>
        <SuccessRegisterModal
          show={getShowSuccessModal}
          onHide={() => hideSuccessModal()}
          modaldata={getModalInfo}
          // aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
        />
        {!viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disabled}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default PaymentInModal;
